import { render, staticRenderFns } from "./RequestPunctual.view.vue?vue&type=template&id=d51ff88a&"
import script from "./RequestPunctual.view.vue?vue&type=script&lang=js&"
export * from "./RequestPunctual.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports